import { render, staticRenderFns } from "./_Tab.vue?vue&type=template&id=5ed84115&scoped=true&"
import script from "./_Tab.vue?vue&type=script&lang=js&"
export * from "./_Tab.vue?vue&type=script&lang=js&"
import style0 from "./_Tab.vue?vue&type=style&index=0&id=5ed84115&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed84115",
  null
  
)

export default component.exports